import { css } from '@emotion/react'
import 'minireset.css'
import 'modern-normalize/modern-normalize.css'

import { Base } from './elements/base'
//import { Overrides } from './elements/overrides'

// import fonts and add it above ${Base} if needed
// add overrides below Base if needed
export const GlobalStyles = css`
  ${Base}
`
